import _ from 'lodash';

import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { HAS_WINDOW, HAS_WINDOW_LISTENERS } from '@eb/feature-detection';

/**
 * Return whether or not an items has been past given height
 */
export const isElementPastViewHeight = (node, height) => {
    if (!HAS_WINDOW) {
        return false;
    }

    return node.getBoundingClientRect().top <= -height;
};

/*
Scroll-related constants

SCROLL_THRESHOLD controls how far down the page the StickyHeader will appear
*/
const SCROLL_DEBOUNCE = 50;
const SCROLL_THRESHOLD = 460;

/*
A wrapper to make any component a "sticky" header

Though not listed as a propType, this component requires a
`parentNode` to be passed through. This helps the component
figure out how far down the page it should stick.

```
<StickyHeader parentNode={node}>
    <TabNavigation
        currentIndex={currentIndex}
        tabs={tabs}
        tabActions={tabActions}
        onClick={onClick}
        CTA={secondaryCTA}
    />
</StickyHeader>
```
*/
export default class StickyHeader extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            willEnter: false,
            willExit: false,
        };

        this._onScroll = _.debounce(this._onScroll.bind(this), SCROLL_DEBOUNCE);
    }

    componentDidMount() {
        if (HAS_WINDOW_LISTENERS) {
            window.addEventListener('scroll', this._onScroll);
        }
    }

    componentWillUnmount() {
        if (HAS_WINDOW_LISTENERS) {
            window.removeEventListener('scroll', this._onScroll);
        }
    }

    _onScroll() {
        this.setState(({ willEnter: prevWillEnter }) => {
            const { parentNode } = this.props;
            let willEnter = false;
            let willExit = false;

            if (
                parentNode &&
                isElementPastViewHeight(parentNode, SCROLL_THRESHOLD)
            ) {
                willEnter = true;
            }

            if (prevWillEnter && !willEnter) {
                willExit = true;
            }

            return {
                willEnter,
                willExit,
            };
        });
    }

    render() {
        const { children } = this.props;
        const { willEnter, willExit } = this.state;
        const className = classNames(
            'tab-navigation--fixed eds-bg-color--white',
            {
                'eds-hide': !willEnter && !willExit,
                'eds-fx--fade-in-down': willEnter,
                'tab-navigation--hidden eds-fx--fade-out-up': willExit,
            },
        );

        if (!children) {
            return null;
        }

        return (
            <div className={className} data-spec="marketing-sticky-header">
                {children}
            </div>
        );
    }
}
